import React, { PropTypes } from 'react';
import WithRetailRate from './with-retail-rate';
import WithoutRetailRate from './without-retail-rate';

const AccommodationRate = ({ rateSet, contractState, ...extraProps }) => {
  const RateTableTemplate = (() => {
    if (rateSet.rates.some(rate => rate.retailRate)) return WithRetailRate;
    return WithoutRetailRate;
  })();
  return <RateTableTemplate {...rateSet} contractState={contractState} {...extraProps} />;
};

AccommodationRate.propTypes = {
  rateSets: PropTypes.array,
};

export default AccommodationRate;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-tables/accommodation-rates-tables/accommodation_rate_table.jsx